import { getIconProps, type IconProps } from '#types'

interface PassOrnamentIconProps extends IconProps {
  strokeWidth?: number
}

/**
 * Decorative double-chevron ornament used on pass/subscription cards.
 */
export function PassOrnamentIcon({ strokeWidth = 1.2, ...props }: PassOrnamentIconProps) {
  return (
    <svg {...getIconProps(props)} viewBox="0 0 17.93 20.71">
      <path
        d="M.42,19.98v-.32l15.5-8.95.62-.36-.62-.36L.42,1.04v-.32l16.68,9.63L.42,19.98ZM.42,17.19V3.51l11.85,6.84L.42,17.19Z"
        stroke="currentColor"
        strokeWidth={strokeWidth}
      />
    </svg>
  )
}
